import { pickBy, identity } from 'lodash-es';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';
import { objectToQueryString } from 'site-modules/shared/utils/string';

const APPRAISAL_HISTORY_URL = '/appraisal/history/';
const APPRAISAL_VALUE_URL = '/appraisal-value/';

export function buildAppraisalHistoryUrl({
  vin = '',
  modsId,
  makeSlug,
  modelSlug,
  year,
  condition = '',
  styleId,
  zipCode,
  mileage,
  optionIds = [],
  isAppExtensionPage = false,
}) {
  const queryParams = objectToQueryString(
    pickBy(
      {
        vin,
        styleId,
        zip: zipCode,
        mileage,
        condition: condition.toUpperCase(),
        optionIds: optionIds.join(','),
        modsId,
      },
      identity
    )
  );
  let appraisalHistoryUrl = APPRAISAL_HISTORY_URL;

  if (makeSlug && modelSlug && year) {
    appraisalHistoryUrl += `${makeSlug}/${modelSlug}/${year}/`;
  }

  if (isAppExtensionPage) {
    // must be appended last
    appraisalHistoryUrl += 'index.app';
  }

  return `${appraisalHistoryUrl}${queryParams ? '?' : ''}${queryParams}`;
}

export const buildAppraisalValueUrl = ({ makeSlug, modelSlug, year }) => {
  if (makeSlug && modelSlug && year) {
    return `/${makeSlug}/${modelSlug}/${year}${APPRAISAL_VALUE_URL}`;
  }
  // Fallback to Appraisal Landing in order to avoid broken URL.
  return URL_PATHS.APPRAISAL_LANDING;
};
